import React, { useState, useEffect } from "react";
import {
  Box
} from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import API_BASE_URL from "../../components/config/appConfig";
import { jwtDecode } from "jwt-decode";
import { toLowerCaseEmail } from "../../utilities/email";
import { AuthBoardArt } from "../Home/authArt";
import { IconBoard, IconUsers, IconShield } from "../Home/landingArt";
import { AuthLayout, AuthNotice, AuthRise } from "../Home/authUi";
import "../Home/home.scss";
import './style.scss';
import OrganizationRegistrationForm from "../../components/Stepper";

const STAGE_POINTS = [
  { icon: IconUsers, label: "Your whole team" },
  { icon: IconBoard, label: "Sprint boards" },
  { icon: IconShield, label: "Secure access" },
];

function OrgRegister() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSubmit = async (values) => {
    const loginData = {
      email: toLowerCaseEmail(values.email),
      password: values.password,
    };

    try {
      const response = await fetch(`${API_BASE_URL}/users/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginData),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("accessToken", data.accessToken);
        if (data.email === "sushmitha.gopari@motivitylabs.com") {
          navigate("/admin/dashboard");
        } else {
          navigate("/projects");
        }
      } else {
        const responsess = await response.json();
        const errorMessage = await responsess.message;
        setError(errorMessage);
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Login error:", error);
      setError("An error occurred. Please try again later.");
      setSnackbarOpen(true);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        if (decodedToken.email === "sushmitha.gopari@motivitylabs.com") {
          navigate("/admin/dashboard");
        } else {
          navigate("/projects");
        }
      } catch (error) {
        console.error("Invalid token or token decoding failed", error);
      }
    }
  }, [navigate]);

  const notice = (
    <AuthNotice open={snackbarOpen} onClose={handleSnackbarClose}>
      {error}
    </AuthNotice>
  );

  return (
    <AuthLayout
      brand="Projam"
      notice={notice}
      variant="au-card--wide au-card--tall"
      title={<>Bring your team<br /><em>on board.</em></>}
      lead="Register your organization, invite the people who do the work, and plan your first sprint."
      points={STAGE_POINTS}
      art={<AuthBoardArt />}
    >
      <h2 className="au-title au-rise" style={{ '--au-d': '.06s' }}>
        Organization registration
      </h2>
      <p className="au-sub au-rise" style={{ '--au-d': '.12s' }}>
        Register your organization to get started
      </p>

      <AuthRise delay={0.18} className="au-stepper">
        <OrganizationRegistrationForm
          snackbarOpen={snackbarOpen}
          setError={setError}
          setSnackbarOpen={setSnackbarOpen}
        />
      </AuthRise>

      <Box className="au-foot au-rise" style={{ '--au-d': '.3s' }}>
        Already have an account?
        <NavLink className="au-link" to="/Organisation">Sign in</NavLink>
      </Box>
    </AuthLayout>
  );
}

export default OrgRegister;
